module.exports = __webpack_public_path__ + "img/95.370a7236.jpg";